<template>
  <div class="basic_wrap video-page">
    <div class="red_top_bg page-top">
      <!-- <div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div> -->
      <div class="big_tit">
        {{ $t('sky.ying') }}
      </div>
      <div class="top_right" />
    </div>
		
    <div class="tab-content page-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box video-box"
      >
        <div class="hot-recommend-div">
          <van-list
            v-model="loading"
            :finished="finished"
            :offset="100"
            :loading-text="$t('pro2.loading')"
            @load="loadVideos"
          >
            <div
              v-if="list.length"
              class="list-item"
            >
              <div
                v-for="(item, index) in list"
                :key="item.id || index"
                class="movie-list-item"
              >
                <div
                  class="cover_img van-image"
                  @click="$router.push('/vplay/'+item.id)"
                >
                  <img
                    :src="formatAssetUrl(item.pic)"
                    class="van-image__img"
                    alt=""
                  >
                </div>
                <div
                  class="movie-list-item-bottom"
                  @click="$router.push('/vplay/'+item.id)"
                >
                  <div class="movie-time-div">
                    <!-- <span>{{item.title}}</span> -->
                    <span>
                      {{ $t('sky.play') }}:{{ item.pnum }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,List,Card,ShareSheet 
	} from "vant";
	import Fetch from "../../utils/fetch";
	import { formatAssetUrl } from "../../utils/assets";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Vindex",
		data() {
			return {
				lang: this.$i18n.locale || "en_us",
				data: null,
				loading: false,
				page: 1,
				limit: 12,
				list: [],
				cur:0,
				type:0,
				islogin: false,
				finished: false,
				empty: false,
				requestLock: false,
			};
		},
		created() {
			this.$parent.footer("video",true);
		},
		mounted() {
			this.islogin = localStorage.getItem('token')!=null;
			if(!this.islogin){
				this.$router.push("/login");
			}
		},
		methods: {
			formatAssetUrl,
			loadVideos() {
				if (this.requestLock || this.finished) {
					return;
				}
				this.requestLock = true;
				this.loading = true;
				Fetch("/index/videos",{
					type:this.cur,
                    page:this.page
                }).then((r) => {
					this.data = r.data;
					var rows = r.data && r.data.list ? r.data.list : [];
					if (rows.length > 0) {
						this.list = this.list.concat(rows);
						this.page++;
					}
					this.empty = this.list.length === 0;
					this.finished = !(r.data && r.data.has_more);
					this.loading = false;
					this.requestLock = false;
				}).catch(() => {
					this.loading = false;
					this.requestLock = false;
					this.finished = true;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
.video-page {
	--accent: #ff5d7a;
	--accent-strong: #ff4f70;
	--accent-soft: #fff1f5;
	--accent-line: #ffdbe4;
	--text: #16223a;
	--muted: #6d7688;
	--shadow: 0 12px 28px rgba(255, 93, 122, 0.13);
	min-height: 100vh;
	height: 100vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background: #fff;
	color: var(--text);
}

.page-top {
	height: 44px;
	flex: 0 0 44px;
	border-bottom: 1px solid #f4edf0;
	background: #fff;
	color: var(--text);
	box-sizing: border-box;

	.big_tit {
		color: var(--text);
	}
}

.page-content {
	flex: 1;
	overflow-y: auto;
	padding-bottom: 100px;
	-webkit-overflow-scrolling: touch;
}

.video-box {
	min-height: 100%;
}

.hot-recommend-div,
.hot-recommend-div /deep/ .van-list {
	width: 100%;
}

.list-item {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 14px 12px;
	padding: 14px 16px 0;
	box-sizing: border-box;
}

.movie-list-item {
	min-width: 0;
	overflow: hidden;
	border: 1px solid var(--accent-line);
	border-radius: 14px;
	background: #fff;
	box-shadow: var(--shadow);
	transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.movie-list-item:active {
	transform: scale(0.98);
	box-shadow: 0 6px 16px rgba(255, 93, 122, 0.16);
}

.cover_img {
	position: relative;
	display: block;
	width: 100%;
	height: auto;
	overflow: hidden;
	border-radius: 13px 13px 0 0;
	aspect-ratio: 1 / 1.28;
	background: var(--accent-soft);
}

.cover_img::after {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	height: 42px;
	content: "";
	background: linear-gradient(180deg, rgba(22, 34, 58, 0) 0%, rgba(22, 34, 58, 0.24) 100%);
	pointer-events: none;
}

.cover_img .van-image__img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.movie-list-item-bottom {
	min-height: 42px;
	padding: 0 10px;
	display: flex;
	align-items: center;
	box-sizing: border-box;
}

.movie-time-div {
	width: 100%;
	display: flex;
	align-items: center;
	color: var(--muted);
}

.movie-time-div span {
	min-width: 0;
	overflow: hidden;
	padding: 4px 8px;
	border-radius: 8px;
	background: var(--accent-soft);
	color: var(--accent);
	font-size: 12px;
	font-weight: 800;
	line-height: 18px;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description,
/deep/ .van-list__loading,
/deep/ .van-list__finished-text {
	color: var(--muted);
}

@media screen and (max-width: 374px) {
	.list-item {
		gap: 10px;
		padding-right: 12px;
		padding-left: 12px;
	}
}
</style>
